import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { ContactesComponent } from './contactes.component';
import { ContactesFiltersComponent } from './contactes-filters/contactes-filters.component';
import { ManageContactesComponent } from './manage-contactes/manage-contactes.component';

import { ListContactesService } from './list.service';
import { FilterEmpresesPipe } from '../pipes/filtreempreses';

import { AngularMaterialModule } from '../angular-material.module';
import { StripHtmlPipe2 } from '../pipes/stripHTMLpipe2';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  providers: [
    ContactesFiltersComponent,
    ManageContactesComponent,
    StripHtmlPipe2,
    ListContactesService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ],
  declarations: [
    ContactesComponent,
    ManageContactesComponent,
    ContactesFiltersComponent,
    FilterEmpresesPipe,
    StripHtmlPipe2
  ],
  exports: [
    ContactesComponent,
    StripHtmlPipe2
  ]
})
export class ContactesModule { }
